// The flyover, mounted at page load as every page did before #2002, when it isn't loaded on demand
// (lazy app loading off; see LazyAppLoadingHelper). flyover_preview/main.ts stands down then.
import { createApp } from 'vue';
import FlyoverPreview from '../apps/flyover_preview/FlyoverPreview.vue';
import store from '../apps/flyover_preview/store/store';
import { i18n } from '../i18n';

const targetElement = document.querySelector('#flyover_preview');

if (targetElement) {
  const app = createApp(FlyoverPreview);
  app.use(store);
  app.use(i18n);
  app.mount(targetElement);
}
